import React from 'react';
import Typography from "@material-ui/core/Typography";
import SearchBar from "../../search";
import AddIcon from "@material-ui/icons/Add";
import ExportToCSV from '../../exportToCSV';

function Index(props) {
  const {
    tableLabel,
    searchValue,
    setSearchValue,
    newIconHandler,
    showSearch = true,
    showAdd = true,
    exportData,
    searchPlaceholder = 'search...'
  } = props;
  return (
    <div>
      <div className='table-title-container'>
        <Typography variant='h4' className='table-title'>
          {tableLabel}
        </Typography>
        {(searchValue != null || showAdd) && <div className='search-bar-container'>
          {showSearch && <SearchBar value={searchValue} onChange={setSearchValue} placeholder={searchPlaceholder}/>}
          {exportData && <ExportToCSV data={exportData}/>}
          {showAdd && <AddIcon className='add-icon mouse-pointer' titleAccess='Add New' onClick={newIconHandler}/>}
        </div>}
      </div>
    </div>
  );
}

export default Index;
